import { useSelector } from "react-redux";
import { selectIsOnline } from "../../../store/slices/network";
import { RootState } from "../../../services/store";
import { selectResidentFluidOutputLogs } from "../../../store/slices/fluidOutput";
import { useFluidOutputHistoryQuery } from "../../../services/api/staticFormsApi";
import { useMemo } from "react";

interface Props {
  residentId?: number;
  currentPage: number;
}

export function useFluidOuputWithOffline({ residentId, currentPage }: Props) {
  const isOnline = useSelector(selectIsOnline);

  const offlineData = useSelector((state: RootState) =>
    selectResidentFluidOutputLogs(state, residentId),
  );

  const {
    data: onlineData,
    isFetching,
    isError,
  } = useFluidOutputHistoryQuery(
    { filter: { resident_id: residentId }, page: currentPage },
    { skip: !residentId },
  );

  const data = useMemo(() => {
    if (isFetching || isOnline) return onlineData?.data;
    if (isError && offlineData) return offlineData;
    return onlineData?.data;
  }, [onlineData, offlineData, isOnline, isFetching, isError]);

  return { data, meta: onlineData?.meta, isFetching };
}
